import axios from "axios"

const currentHost = window.location.origin

const api = () => {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  }
  if ((window as any).xSandbox) {
    headers["x-sandbox"] = (window as any).xSandbox
  }
  return axios.create({ baseURL: currentHost, headers })
}

export const API_DATE_REGEX = /^\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d\d\d)?Z?$/

type ApiFieldError = { field: string; message: string }
type ApiFileInfo = {
  uuid: string
  filename: string
  url: string
  expires_at: string
}

export default api
export { ApiFieldError, ApiFileInfo }
